import { SelectOptions } from 'app/@theme/components/select/select.component';

export const INACTIVATION_REASON_VALUES = {
  NOT_PART_OF_COMPANY: 'Contato não faz mais parte da empresa',
  DUPLICATE_REGISTRATION: 'Duplicidade de cadastro',
  OTHER: 'Outros'
} as const;

export type InactivationReasonValue =
  (typeof INACTIVATION_REASON_VALUES)[keyof typeof INACTIVATION_REASON_VALUES];

export const INACTIVATION_REASON_OPTIONS: ReadonlyArray<SelectOptions<unknown>> = [
  {
    id: 'inactivation-reason-not-part-of-company',
    value: INACTIVATION_REASON_VALUES.NOT_PART_OF_COMPANY,
    label: 'platform.client_area.client_data_form_contacts_inactivation_reason_option_not_part_of_company'
  },
  {
    id: 'inactivation-reason-duplicate',
    value: INACTIVATION_REASON_VALUES.DUPLICATE_REGISTRATION,
    label: 'platform.client_area.client_data_form_contacts_inactivation_reason_option_duplicate'
  },
  {
    id: 'inactivation-reason-other',
    value: INACTIVATION_REASON_VALUES.OTHER,
    label: 'platform.client_area.client_data_form_contacts_inactivation_reason_option_other'
  }
];

export const INACTIVATION_REASON_DETAIL_MAX_LENGTH = 500;
export const INACTIVATION_REASON_DETAIL_MIN_TRIMMED_LENGTH = 1;
